import React from 'react';
import { Helmet } from 'react-helmet-async';

const MetaTags = (): React.JSX.Element => {
	return (
		<Helmet>
			<meta content="Rovo Extension" name="application-name" />
		</Helmet>
	);
};

export default MetaTags;
